export default "__VITE_ASSET__FHCr32Y9__"